<template>
    <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content" name="popUpGestioneIntervento" @before-open="getIntervento" >
        <div class="BtnClose">
            <span style="cursor:pointer"><mdi-close @click="this.closeModal()" ></mdi-close></span>
        </div>
        <div class="PopUpBox">
            <div class="PopUpTitle Iconed AddNote">Fine gestione Intervento</div>
            <div class="PopUpContent">
                <form class="Form">
                    <fieldset>
                        <div class="FormRow">
                            <div class="FormBoxWide">
                                <label>Data Gestione</label>
                                <input type="date" placeholder="Inserisci la data" v-model="this.dataSelected"/>
                            </div>
                        </div>
                        <div class="FormRow">
                            <div class="FormBoxWide">
                                <label>Note:</label>
                                <textarea v-model="this.note"></textarea>
                            </div>
                        </div>
                        <div class="FormRow">
                            <div class="FormBoxWide">
                                <label>Referente Azienda:</label>
                                <input type="text" id="" name="" placeholder="Referente Azienda" v-model="this.referente" />
                            </div>
                        </div>
                        <div class="FormRow">
                            <div class="FormBoxWide">
                                <div class="TwinButtons">
                                <div class="Button  ExtraSmall"><input type="button"  value="Salva" @click="this.salvaNota(1)"></div>
                                <div class="Button  ExtraSmall"><input type="button"  value="Annulla" @click="this.note=''"></div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
            <div class="PopUpFooter">
                <form>
                    <div class="Button CustomColor2"><input type="button" @click="this.gestisciIntervento()" value="Segnala come Gestito"></div>
                </form>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>

import MdiClose from "@/components/modals/MdiClose.vue";
import Intervento from "@/models/intervento.model.js";
import {apiMixin,dateMixin} from "/mixin.js";

export default {
    name: "GestioneInterventoModal",
    props: {
        intervento: Object,
        showModal: Boolean
    },
    components:{
        MdiClose
    },
    mixins: [apiMixin,dateMixin],
    data(){
        return {
            note: this.intervento.NoteGestione,
            referente : this.intervento.ReferenteAzienda,
            dataSelected: ""
        }
    },
    methods: {
        closeModal: function(){
            this.$vfm.hide('popUpGestioneIntervento');
        },
        salvaNota: async function(){
            let postBody = {
                "SysChiaveglobale" : this.intervento.SysChiaveglobale,
                "NoteGestione" : this.note,
                "Referente": this.referente,
                "DataGestione": this.formatDate(this.dataSelected ?? Date.now())
            };
            this.doApiCall("post", "interventi/SetNoteGestione", this.$store.getters.getUtente.Token, null, postBody).then(
                (data) => {             
                    if(data.StatusCode === 200){
                        this.$toast.success("Nota salvata con successo!", {position:"top-right"});                  
                        let griglia = this.$parent.$parent.$parent.$parent;                
                        let index = griglia.listaInterventi.findIndex(item => {return item.SysChiaveglobale === data.Data.SysChiaveglobale});                    
                        griglia.listaInterventi[index] = data.Data;  
                        griglia.$forceUpdate();     
                        return 0;                   
                    }
                    else{
                        this.$toast.error("Attenzione! Si sono verificati errori durante il salvataggio della nota!", {position:"top-right"});
                        return -1
                    }
                }
            );
        },
        gestisciIntervento(){
            this.salvaNota().then(
                (data) =>{
                    let postBody = {
                        DataGestione: this.formatDate(this.dataSelected ?? Date.now()),
                        SysChiaveglobale : this.intervento.SysChiaveglobale,
                    };      
                    this.doApiCall("post", "interventi/Gestisci", this.$store.getters.getUtente.Token, null, postBody).then(
                        (data) => {             
                            if(data.StatusCode === 200){
                                this.$toast.success("Intervento gestito con successo!", {position:"top-right"});                  
                                let griglia = this.$parent.$parent.$parent.$parent;
                                let index = griglia.listaInterventi.findIndex(item => {return item.SysChiaveglobale === data.Data});                         
                                griglia.listaInterventi.splice(index, 1); 
                                griglia.$forceUpdate();
                                this.$vfm.hide('popUpGestioneIntervento');
                            }
                            else{
                                this.$toast.error("Attenzione! Si sono verificati errori durante la gestione dell'intervento!", {position:"top-right"});
                            }
                        }
                    );
                }
            );
        },
        getIntervento: function(){
            let keys = this.intervento.SysChiaveglobale.split('~|~');
            let postBody = {
                "CodiceIntervento": keys[1]
            }
            this.doApiCall("get", "interventi/GetDettaglioIntervento", this.$store.getters.getUtente.Token,postBody).then(
                (data) => {               
                    if(data){
                    Object.assign(new Intervento(), data);
                    this.notePresaInCarico = data.NotePresaInCarico;
                    this.referente = data.ReferenteAzienda;               
                    }
                }
            );
        } 

    }
}
</script>

<style>
input[type="date"]{-webkit-appearance:none;appearance:none;}
input[type="date"]{width:100%;}
input[type="date"]{background-color:#ffffff;border:1px solid #cccccc;box-shadow:0 0 6px 0 rgba(0,0,0,0.00) inset;border-radius:0;font-family:'Open Sans', sans-serif;font-size:13px;color:#252525;}
input[type="date"]{height:36px;padding-top:3px;padding-right:12px;padding-bottom:3px;padding-left:12px;}npm 
input[type="date"]:focus{border-color:#e10712;box-shadow:0 0 6px 0 rgba(0,0,0,0.00) inset;}
</style>